import React from 'react';

export function LeadsSkeleton() {
  return (
    <div className="min-h-full animate-pulse bg-muted/30 p-4 motion-reduce:animate-none md:p-6">
      <div className="mx-auto max-w-7xl space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <div className="h-7 w-40 rounded bg-muted" />
            <div className="h-4 w-72 rounded bg-muted" />
          </div>
          <div className="flex gap-2">
            <div className="h-9 w-24 rounded-md bg-muted" />
            <div className="h-9 w-28 rounded-md bg-muted" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-24 rounded-lg bg-muted" />
          ))}
        </div>

        <div className="h-14 rounded-lg bg-muted" />
        <div className="h-96 rounded-lg bg-muted" />
      </div>
    </div>
  );
}
